import { API_ENDPOINTS } from "../../../../config/api";
import { React, useState, useEffect } from "react";
import Breadcrumbs from "../../../../components/Breadcumbs";
import { useAlert } from "../../../../hooks/AlertHook";
import ReactImageMagnify from "react-image-magnify";
import { useNavigate } from "react-router-dom";
import { saveAs } from "file-saver";
import axios from "axios";

export default function ScreeningsPage(props) {
  // const [collection, setCollection] = useState("");
  const [modalImage, setModalImage] = useState("");
  const [modalName, setModalName] = useState("");
  const [modalDate, setModalDate] = useState("");
  const [screenings, setScreenings] = useState([]);
  const navigate = useNavigate();
  var deviceid = props.deviceSelected.ID;
  var collectionid = props.collectionSelected;
  const alerta = useAlert();

  const pages = [
    {
      name: "Devices",
      href: "/dash/devices",
      current: false,
    },
    {
      name: "Collections",
      href: `/dash/devices/${deviceid}/collection`,
      current: true,
    },
    { name: "Screenings", href: "", current: true },
  ];

  useEffect(() => {
    // let { token } = JSON.parse(localStorage.getItem('BACK_API')) || {};

    // Consultar coleccion seleccionada
    // axios.post(
    //   'http://40.87.58.82:8000/getcollections',
    //   { deviceid },
    //   // { headers: {authorization: `bearer ${token}`}}
    // ).then((respuesta) => {
    //   let collection_selected = respuesta.data.find(collection => collection.ID === props.collectionSelected)

    //   if (respuesta.data.length > 0) {
    //     setCollection(collection_selected)
    //   } else {
    //     navigate(`/dash/devices/${deviceid}/collection`)
    //   }
    // }).catch((error) => {
    //   console.log('error:', error)
    //   // navigate('/auth/login')
    // });

    // Consultar imagenes de la coleccion
    axios
      .post(
        API_ENDPOINTS.GET_SCREENINGS,
        { deviceid, collectionid }
        // { headers: {authorization: `bearer ${token}`}}
      )
      .then((respuesta) => {
        if (respuesta.data.length > 0) {
          alerta.setShow(false);
          setScreenings(respuesta.data);
        } else {
          alerta.setMessage("Collection is Empty");
          alerta.setShow(true);
          setTimeout(() => {
            alerta.setShow(false);
            navigate(`/dash/devices/${deviceid}/collection`);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log('error:', error)
        // navigate("/auth/login");
      });
  }, [deviceid, collectionid, navigate, alerta]);

  const openScreen = (screen_selected, index) => {
    console.log(screen_selected);

    let screen_container = document.getElementById("screen-container"),
      modal_container = document.getElementById("modal-container"),
      modal_position = document.getElementById("modal-position"),
      modal_image = `/downloadscreeningbyurl?imagename=${screen_selected.rawfilepath}`;

    // ocultar listado de imagenes
    screen_container.classList.add("hidden");
    // mostrar modal
    modal_container.classList.remove("hidden");
    setModalImage(modal_image);
    setModalName(screen_selected.scanimagename);
    setModalDate(screen_selected.CreatedAt);
    modal_position.value = index;

    // validar que posiciones estan disponibles
    let next_screen = screenings[Number(index) + 1];
    let previous_screen = screenings[Number(index) - 1];

    let modal_next = document.getElementById("modal-next");
    if (next_screen) {
      modal_next.removeAttribute("disabled");
    } else {
      modal_next.setAttribute("disabled", true);
    }

    let modal_previous = document.getElementById("modal-previous");
    if (previous_screen) {
      modal_previous.removeAttribute("disabled");
    } else {
      modal_previous.setAttribute("disabled", true);
    }
  };

  const closeScreen = () => {
    let modal_container = document.getElementById("modal-container"),
      screen_container = document.getElementById("screen-container");

    modal_container.classList.add("hidden"); // ocultar modal
    screen_container.classList.remove("hidden"); // mostrar listado de imagenes
  };

  const nextScreen = () => {
    let modal_position = document.getElementById("modal-position").value;
    modal_position = Number(modal_position) + 1;

    let next_screen = screenings[modal_position];

    if (next_screen) {
      openScreen(next_screen, modal_position);
    } else {
      console.log("no disponible");
      // let modal_next = document.getElementById('modal-next')
      // modal_next.setAttribute('disabled', true)
    }
  };

  const previousScreen = () => {
    let modal_position = document.getElementById("modal-position").value;
    modal_position = Number(modal_position) - 1;

    let previous_screen = screenings[modal_position];

    if (previous_screen) {
      openScreen(previous_screen, modal_position);
    } else {
      console.log("no disponible");
      // let modal_previous = document.getElementById('modal-previous')
      // modal_previous.setAttribute('disabled', true)
    }
  };

  const downloadScreen = () => {
    saveAs(modalImage, `videcloud_${modalName}_${modalDate}.jpg`); // Put your image url here.
  };

  const showScreening = (
    <div
      id="screen-container"
      className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 gap-x-6 lg:grid-cols-3 xl:grid-cols-4 xl:gap-x-8 px-4 py-5 sm:p-6"
    >
      {screenings.map((screen, index) => (
        <div key={`screen-${screen.ID}`}>
          <button
            type="button"
            onClick={() => openScreen(screen, index)}
            className="block w-full aspect-w-1 aspect-h-1 bg-gray-200 rounded-lg overflow-hidden xl:aspect-w-7 xl:aspect-h-8"
          >
            <img
              src={`/downloadscreeningbyurl?imagename=${screen.rawfilethumbnailpath}`}
              alt="rawfilethumbnailpath"
              className="w-full h-full object-center object-cover group-hover:opacity-75"
            />
          </button>
          <p className="mt-4 text-sm text-gray-700">{screen.offsetdatetime}</p>
          <h3 className="mt-1 text-lg font-medium text-gray-900">
            {screen.scanimagename}
          </h3>
        </div>
        ))}
    </div>
  )

  const showAlert = (
    <div className="alert alert-yellow">
      <span>{alerta.message}</span>
    </div>
  );

  const cardContent = screenings.length > 0 ? showScreening : showAlert;

  return (
    <>
      <Breadcrumbs pages={pages} />
      <div className="card">
        <div className="px-4 py-5 sm:px-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900">
            Screenings for "Default"
            {/* Screenings for "{collection.collectionname}" */}
          </h3>
        </div>

        <div className="">
          {cardContent}

          <div
            id="modal-container"
            className="hidden flex flex-col lg:flex-row justify-between px-4 py-5 sm:p-6"
          >
            <div className="w-full lg:w-1/2">
              <ReactImageMagnify
                {...{
                  smallImage: {
                    alt: "Videcloud",
                    isFluidWidth: true,
                    src: modalImage,
                  },
                  largeImage: {
                    src: modalImage,
                    width: 1200,
                    height: 1800,
                  },
                  enlargedImageClassName: "modal-img",
                  lensStyle: {
                    background: 'rgba(255, 255, 255, .5)',
                  }
                }}
              />
            </div>

            <div
              id="zoomID"
              className="w-full mt-4 lg:mt-0 lg:ml-4 text-right flex flex-col justify-between"
            >
              <div>
                <p id="modal-date" className="mt-4 text-sm text-gray-700">
                  {modalDate}
                </p>
                <strong className="mt-1 text-lg font-medium text-gray-900">
                  {modalName}
                </strong>
              </div>

              <div className="grid lg:grid-cols-2 gap-2">
                <input id="modal-position" type="hidden" />
                <button onClick={downloadScreen} className="btn-secondary">
                  Download Image
                </button>
                <button onClick={closeScreen} className="btn-secondary">
                  Grid View
                </button>
                <button
                  id="modal-previous"
                  onClick={previousScreen}
                  className="btn-secondary mt-4"
                >
                  Previous
                </button>
                <button
                  id="modal-next"
                  onClick={nextScreen}
                  className="btn-secondary mt-4"
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="h-1"></div>
    </>
  );
}
